$(() => {
  let observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      entry.target.classList.toggle(
        'scrollable',
        entry.target.scrollWidth > entry.target.clientWidth,
      )
    }
  })

  $('.table-wrapper').each(function () {
    observer.observe(this)
  })
})
